<template>
  <div class="lpu-doctors-schedule-specialty">
    <button
      type="button"
      data-qa="lpu_doctors_schedule_specialty_btn"
      class="lpu-doctors-schedule-specialty__button d-flex align-center w-100"
      :disabled="disabled || !specialities.length"
      @click="isDrawerOpen = true"
    >
      <span
        class="text-body-1 flex-grow-1 text-left text-truncate"
        :class="selectedSpeciality ? 'text--text' : 'text-secondary--text'"
      >
        {{ selectedSpeciality?.name || tStatic('Специальность') }}
      </span>
      <span class="ui-icon-arrow-down text-secondary--text lpu-doctors-schedule-specialty__icon flex-shrink-0" />
    </button>

    <CoreSelectionDrawer
      has-search
      is-checked-variant
      :value="isDrawerOpen"
      :title="tStatic('Специальность')"
      :placeholder="tStatic('Название специальности')"
      :items="specialities"
      :selected-item="selectedSpeciality || undefined"
      @input="isDrawerOpen = false"
      @click-item="handleSelect"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import CoreSelectionDrawer from 'src/core/CoreSelectionDrawer/CoreSelectionDrawer.vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { LpuSpecialityOption } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsSchedule/api/apiLpuSpecialities.types'

type Emits = {
  (_event: 'select', _speciality: LpuSpecialityOption): void
}

defineProps<{
  specialities: LpuSpecialityOption[]
  selectedSpeciality: LpuSpecialityOption | null
  disabled?: boolean
}>()

const emit = defineEmits<Emits>()

const isDrawerOpen = ref(false)

function handleSelect(speciality: unknown) {
  emit('select', speciality as LpuSpecialityOption)
  isDrawerOpen.value = false
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.lpu-doctors-schedule-specialty {
  width: 100%;

  &__button {
    box-sizing: border-box;
    min-height: 48px;
    padding: 14px 16px;
    border: 1px solid $color-deep-soft-blue;
    border-radius: $border-radius-sm;
    background-color: $ui-kit-bg-gray-0;
    cursor: pointer;
    appearance: none;

    &:disabled {
      cursor: default;
      opacity: 0.6;
    }
  }

  &__icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    line-height: 16px;
  }
}
</style>
